import HowToQualifyVaroAdvance from 'features/advance/screens/manageAdvanceAccount/HowToQualifyVaroAdvance/HowToQualifyVaroAdvance';
import React from 'react';

export default function HowToQualifyVaroAdvancePage() {
  return <HowToQualifyVaroAdvance />;
}
